<template>
    <div class="cz2__panel cz2__panel--secondary cz2__panel--secondary-fullscreen">
        <focus-lock :disabled="focusLockDisabled">

            <!-- Panel Header -->
            <div class="cz2__panel__header">
                <details-header></details-header>
            </div>

            <!-- Panel Body -->
            <div :class="[
                'cz2__panel__body',
                'cz2__panel__body--with-html',
                {
                    'cz2__panel__body--hack': panelBodyHack
                }
            ]">
                <panel-header
                    :title="title"
                    :align="isFullHeight ? 'left' : 'center'"
                />

                <!-- Panel-specific content -->
                <slot></slot>

            </div>

            <!-- Actions -->
            <slot name="actions">
            </slot>
        </focus-lock>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    .cz2__panel-body__back-button {
        margin-bottom: 20px;
    }
</style>

<script>
    import FocusLock from 'vue-focus-lock';
    import DetailsHeader from './DetailsHeader.vue';
    import PanelHeader from './PanelHeader.vue';
    import PanelBodyHack from './PanelBodyHack';

    export default {
        mixins: [PanelBodyHack],
        components: {
            FocusLock,
            DetailsHeader,
            PanelHeader,
        },
        props: {
            title: {
                type: String,
                default: 'Back', // TODO: find out how to access this.$t('MENU_BACK') in props
            },
            subTitle: {
                type: String,
                default: null,
            },
            helpContent: {
                // TODO: add content here to decide if we want to show the help menu
            },
            isFullHeight: {
                type: Boolean,
                default: true,
            },

            // showDetailsHeader, // either use the standard product details header, or override with our data and back button
            // content,
            // panelClass = cz2__product-details
        },
        data() {
            return {
                focusLockDisabled: true,
            };
        },
        computed: {
            /**
             * Current view controller.
             */
            viewController() {
                return this.$store.state.customizer.viewController;
            },

            /**
             * Retrives panel content.
             */
            content() {
                if (this.viewController == null) {
                    return '';
                }

                return this.viewController.blueprint.custom['v-product-details-html'] || '';
            },
        },
        mounted() {
            // Otherwise this messes with transition animation because browsers will try to scroll to the focused item, which would be off-screen.
            this.$store.state.eventBus.$once('secondaryEntered', () => {
                // this.focusLockDisabled = false;
            });
        },
        methods: {
            /**
             * Go back.
             */
            cancel() {
                this.$emit('cancel');
            },
        },
    };
</script>
